export default __webpack_public_path__ + "static/media/docs-cortisol-kidney.0bd57975.png";